var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPosition = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5005 24C15.3508 24.0008 15.2096 23.9302 15.1205 23.81C14.9105 23.51 10.0005 16.62 10.0005 13.65C9.96153 10.572 12.4225 8.04389 15.5005 8C18.5784 8.04389 21.0394 10.572 21.0005 13.65C21.0005 16.65 16.0905 23.51 15.8805 23.81C15.7913 23.9302 15.6502 24.0008 15.5005 24ZM15.5005 8.94C14.2698 8.95843 13.0969 9.46504 12.2398 10.3484C11.3828 11.2317 10.9117 12.4194 10.9305 13.65C10.9305 15.65 13.9305 20.47 15.5005 22.72C17.0605 20.47 20.0705 15.72 20.0705 13.65C20.0892 12.4194 19.6182 11.2317 18.7611 10.3484C17.904 9.46504 16.7311 8.95843 15.5005 8.94ZM15.5005 12.53C14.6672 12.5463 14.0003 13.2266 14.0005 14.06C14.0006 14.6815 14.3767 15.2412 14.9521 15.4762C15.5275 15.7111 16.1879 15.5746 16.623 15.1308C17.0581 14.687 17.1815 14.0241 16.9352 13.4534C16.6889 12.8828 16.1219 12.5178 15.5005 12.53ZM15.5005 11.53V11.56C16.8812 11.56 18.0005 12.6793 18.0005 14.06C17.9839 15.4367 16.8574 16.5409 15.4807 16.5299C14.104 16.5189 12.9952 15.3969 13.0007 14.0201C13.0061 12.6433 14.1237 11.5301 15.5005 11.53Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPosition);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Position.848550a178d089ff4b931733af28b552.svg";